export enum MenuItem {
  FEATURE = 'feature',
  PINNED_APP = 'pinned_app',
}

interface BaseMenuItem {
  name: string;
  href: string;
}

interface FeatureProperties {
  isNew?: boolean;
  isPremium?: boolean;
}

export interface FeatureMenuItem extends BaseMenuItem, FeatureProperties {
  type: MenuItem.FEATURE;
}
export interface PinnedAppMenuItem extends BaseMenuItem, FeatureProperties {
  type: MenuItem.PINNED_APP;
  logo?: string;
}

export type MenuItemType = FeatureMenuItem | PinnedAppMenuItem;

//type guards
export const isPinnedAppMenuItem = (
  item: MenuItemType,
): item is PinnedAppMenuItem => item.type === MenuItem.PINNED_APP;

export const isFeatureMenuItem = (
  item: MenuItemType,
): item is FeatureMenuItem => item.type === MenuItem.FEATURE;
